// MenuColumnV3 — single column inside the mega-menu panel.
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MenuColumnV3({ group, testIdPrefix }) {
    const { t } = useTranslation("header_v3");
    return (
        <div className="flex flex-col gap-1" data-testid={`${testIdPrefix}-column-${group.key}`}>
            <div className="text-[10px] uppercase tracking-widest text-[#999999] font-semibold pb-2 border-b border-white/5 mb-2">
                {t(group.i18n)}
            </div>
            {group.items.map((item) => {
                const isExternal = item.href.startsWith("mailto:") || item.href.startsWith("http");
                const cls = "block px-3 py-2 rounded-lg text-sm text-white/90 hover:text-white hover:bg-white/[0.04] transition-colors no-underline";
                if (isExternal) {
                    return (
                        <a key={item.key} href={item.href} className={cls} data-testid={`${testIdPrefix}-item-${item.key}`}>
                            {t(item.i18n)}
                        </a>
                    );
                }
                return (
                    <Link key={item.key} to={item.href} className={cls} data-testid={`${testIdPrefix}-item-${item.key}`}>
                        {t(item.i18n)}
                    </Link>
                );
            })}
        </div>
    );
}
